import React from 'react';
import { UserButton, useUser, useClerk } from '@clerk/react';
import { contentLabels } from '../config/contentLabels';

interface SiteHeaderProps {
  showTagline?: boolean;
  onAdminClick?: () => void;
}

const SiteHeader: React.FC<SiteHeaderProps> = ({ showTagline = false, onAdminClick }) => {
  const { isSignedIn } = useUser();
  const { openSignIn } = useClerk();

  return (
    <header className="blog-header">
      <div className="site-header-auth">
        {onAdminClick && (
          <button className="admin-link-button" onClick={onAdminClick}>
            Admin
          </button>
        )}
        {isSignedIn ? (
          <UserButton />
        ) : (
          <button className="sign-in-button" onClick={() => openSignIn()}>
            Sign in
          </button>
        )}
      </div>
      <div className="logo-container">
        <img src="/logo-1.png" alt="BaldyDev Logo" className="blog-logo" />
      </div>
      <h1 className="blog-list-title">{contentLabels.siteTitle}</h1>
      {showTagline && <p className="blog-subtitle">{contentLabels.siteTagline}</p>}
    </header>
  );
};

export default SiteHeader;
